import {deserialize} from "cerialize";
import {Entity} from "../entity";

export class documentObligatoire{
  @deserialize
  public id: number;

  @deserialize
  nom: string;

  @deserialize
  slug: string;
}
